export const PaymentBrand = Object.freeze({
    AMERICAN_EXPRESS: "American Express",
    DINERS_CLUB: "Diners Club",
    DISCOVER: "Discover",
    JCB: "JCB",
    MAESTRO: "Maestro",
    MASTERCARD: "MasterCard",
    VISA: "Visa",
});
